"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));
var _i18n = require("../../../../../Framework/i18n");
var _Carousel = _interopRequireDefault(require("../../../../../Framework/Components/Carousel"));
var _customClassName = _interopRequireDefault(require("../../../../Utils/customClassName"));
var _ProductPart = _interopRequireDefault(require("../ProductPart"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      zIndex: 1,
      '&.horizontal': _defineProperty({
        position: 'absolute',
        bottom: 8,
        height: 'auto',
        // the available width (see container) is reduced by the width of the two arrows
        width: 'calc(100% - 72px)'
      }, theme.breakpoints.down('xs'), {
        width: 'calc(100% - 32px)',
        padding: '0 16px'
      }),
      '&.vertical': _defineProperty({
        "float": 'left',
        height: '100%',
        width: 'auto',
        marginLeft: theme.creator.productPartsList.marginLeft,
        paddingTop: theme.creator.productPartsList.paddingTop
      }, theme.breakpoints.down('md'), {
        paddingTop: 35
      })
    }
  };
}, {
  name: 'ProductPartsList'
});
var ProductPartsList = function ProductPartsList(_ref) {
  var displaySwitchedOptions = _ref.displaySwitchedOptions,
    onSelect = _ref.onSelect,
    optionclassifications = _ref.optionclassifications,
    selectedoptionclassification = _ref.selectedoptionclassification,
    showStartHere = _ref.showStartHere,
    vertical = _ref.vertical,
    ProductPartComponent = _ref.ProductPartComponent,
    CallToActionComponent = _ref.CallToActionComponent,
    width = _ref.width,
    optionListVisible = _ref.optionListVisible,
    onCloseSelectedPart = _ref.onCloseSelectedPart;
  var classes = useStyles();
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorRef = _useState2[0],
    setAnchorRef = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Carousel["default"], {
    className: (0, _clsx["default"])(classes.root, (0, _customClassName["default"])('components')),
    vertical: vertical
  }, optionclassifications.map(function (option, index) {
    var refProps = _objectSpread({}, index === 0 && {
      setAnchorRef: setAnchorRef
    });
    return /*#__PURE__*/_react["default"].createElement(ProductPartComponent, _extends({
      key: 'optionclassificationitem' + option.identifier,
      displaySwitchedOptions: displaySwitchedOptions,
      onSelect: onSelect,
      optionclassification: option,
      selectedOption: selectedoptionclassification,
      verticalMode: vertical,
      optionListVisible: optionListVisible,
      onCloseSelected: onCloseSelectedPart
    }, refProps));
  })), showStartHere && width !== 'xs' && /*#__PURE__*/_react["default"].createElement(CallToActionComponent, {
    offsetDirection: vertical ? 'right' : 'top',
    anchorRef: anchorRef,
    perpendicularOffset: vertical ? -15 : 0,
    offset: 15,
    label: (0, _i18n.T)('creator.startHere'),
    className: (0, _customClassName["default"])('begin-here-creator')
  }));
};
ProductPartsList.defaultProps = {
  onSelect: function onSelect() {},
  optionclassifications: [],
  selectedoptionclassification: {},
  showStartHere: false,
  vertical: true,
  ProductPartComponent: _ProductPart["default"],
  onCloseSelectedPart: function onCloseSelectedPart() {}
};
var _default = exports["default"] = (0, _withWidth["default"])({
  initialWidth: 'lg'
})(ProductPartsList);